// extracted by mini-css-extract-plugin
export default {"Options":"RemoveRevisionModal_Options__JLAhr"};